import React from 'react'
import styled, {css} from 'styled-components'

import Loader from 'components/loader'

import theme, {bp} from 'settings/theme'

type Props = {
    position?: "inline" | "stretch"
    height?: string,
    loaderProps?: {
        size?: number
    }
}

type StyledProps = Props



// Component
const Component: React.FC<Props> = (props) => {

	return(
        <StyledComponent position={props.position} height={props.height} className="loaderCover">
            <Loader {...props.loaderProps} />
        </StyledComponent>
	)

}

Component.defaultProps = {
    position: "inline",
} as Partial<Props>

export default Component


// Styles
const StyledComponent = styled.div<StyledProps>`

    ${props => props.position === 'inline' &&
        css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: ${props.height};
        `
    }

    @media (min-width: ${bp(3)}) {
        
    }



`